import React, { useState } from "react"
import PropTypes from "prop-types"
import * as yup from "yup"
import { useTranslation } from "react-i18next"
import { Formik, Form, Field } from "formik"
import { Spacer, Button } from "@bw/bits"
import { Input, FormField } from "@bw/forms"

const Forgot = ({ onSubmit, setActiveStep }) => {
  const [submitted, setSubmitted] = useState(false)
  const { t } = useTranslation()
  const initialValues = { email: "" }

  return (
    <Spacer>
      <Formik
        initialValues={initialValues}
        validationSchema={yup.object().shape({
          email: yup.string().required(),
        })}
        onSubmit={(values, actions) => {
          actions.setSubmitting(true)

          onSubmit(values).then(() => {
            setSubmitted(true)
          }).finally(() => {
            actions.setSubmitting(false)
          })
        }}
      >
        {({ values, isSubmitting }) => {
          return submitted ?
            <p>{t("authentication:yourPasswordRequestHasBeenSent", { email: values.email })}</p>
            :
            <Form>
              <FormField title={t("authentication:email")} name="email">
                <Field type="text" id="email" name="email" component={Input} />
              </FormField>

              <Button
                submit
                small
                label={t("authentication:forgotSubmit")}
                disabled={isSubmitting}
              />
            </Form>
        }}
      </Formik>
      <div>
        <Button
          onClick={() => setActiveStep("login")}
          plain
          small
          label={t("authentication:iRememberMyPassword")}
        />
      </div>
    </Spacer >
  )
}

Forgot.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
}

export default Forgot
